// Source/Expandable/Debounce.ts
function debounce(func, wait) {
  let timeout = null;
  return (...args) => {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(() => {
      func(...args);
    }, wait);
  };
}

// Source/Filter-Events/mod.ts
var Event_Name = "Boost:Filter:Change";
window.addEventListener("Boost:After-Render", onRender);
var observer = new MutationObserver(debounce(onChange, 200));
observer.observe(getContainer(), {
  childList: true,
  subtree: true
});
function onRender() {
  dispatchChange();
}
function onChange() {
  dispatchChange();
}
function dispatchChange() {
  const event = new CustomEvent(Event_Name);
  window.dispatchEvent(event);
}
function getContainer() {
  return document.querySelector(`.boost-sd__filter-product-list`);
}
var scripts = document.querySelectorAll(`script[ data-use = 'Hidden-Correct' ]`);
var filters = Array.from(scripts).map((script) => script.textContent).map((json) => JSON.parse(json)).map((data) => data.Filters).flat();
var ids = filters.map((filter) => `${filter.Key}:${filter.Value}`);
window.addEventListener(Event_Name, () => {
  const list = document.querySelector(`.boost-sd__refine-by-vertical-refine-by-list`);
  if (!list)
    return;
  const buttons = Array.from(list.children);
  for (const button of buttons) {
    if (button.dataset.hidden)
      return;
    const json = button.getAttribute("metadata");
    const meta = JSON.parse(json);
    const { value, key } = meta.action.clearFilter;
    const id = `${key}:${value}`;
    if (ids.includes(id))
      button.dataset.hidden = String(true);
  }
});
